import api from "./api";

export function getCourseFinderPage(country_id) {
  return api.get(`/coursefinderpage/${country_id}`);
}
